import { render, staticRenderFns } from "./AddSector.vue?vue&type=template&id=3c998b20&scoped=true&"
import script from "./AddSector.vue?vue&type=script&lang=js&"
export * from "./AddSector.vue?vue&type=script&lang=js&"
import style0 from "./AddSector.vue?vue&type=style&index=0&id=3c998b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c998b20",
  null
  
)

export default component.exports